// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"M1-z","displaySixCardTiles":"N1-z"};